import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from '../TextField/component';

import './style.scss';

export class MediaCitationSettings extends React.PureComponent {
  static propTypes = {
    citationText: PropTypes.string,
    citationLink: PropTypes.string,

    citationTextError: PropTypes.string,
    citationLinkError: PropTypes.string,

    citationTextOnChange: PropTypes.func.isRequired,
    citationLinkOnChange: PropTypes.func.isRequired,

    citationTextOnBlur: PropTypes.func,
    citationLinkOnBlur: PropTypes.func,

    className: PropTypes.string,
  };

  static defaultProps = {
    citationText: '',
    citationLink: '',
    citationTextError: null,
    citationLinkError: null,
    citationTextOnBlur: () => {},
    citationLinkOnBlur: () => {},
    className: null,
  };

  render() {
    const {
      citationText,
      citationLink,

      citationTextError,
      citationLinkError,

      citationTextOnChange,
      citationLinkOnChange,

      citationTextOnBlur,
      citationLinkOnBlur,

      className,
    } = this.props;

    return (
      <media-citation-settings class={className}>
        <TextField
          className="media-citation-settings-field"
          label="Display text"
          type="text"
          value={citationText}
          onValueChange={citationTextOnChange}
          onBlur={citationTextOnBlur}
          error={citationTextError}
        />
        <TextField
          className="media-citation-settings-field"
          label="Link to source"
          type="url"
          value={citationLink}
          onValueChange={citationLinkOnChange}
          onBlur={citationLinkOnBlur}
          error={citationLinkError}
        />
      </media-citation-settings>
    );
  }
}
